import { chakra, useStyleConfig } from '@chakra-ui/react';
import ru from 'date-fns/locale/ru';
import { InputVariant } from 'presentation/theme/components/input';
import { FC } from 'react';
import DatePicker, {
  ReactDatePickerProps,
  registerLocale,
} from 'react-datepicker';
import InputMask from 'react-input-mask';
import { useTranslation } from 'react-i18next';
import TextInput from './TextInput';

registerLocale('ru', ru);

export interface DateInputProps extends ReactDatePickerProps {}

const ChakraDatePicker = chakra(DatePicker);

const DateInput: FC<DateInputProps> = (props) => {
  const { i18n } = useTranslation();
  const styles = useStyleConfig('Input', {
    variant: InputVariant.filled,
  });

  return (
    <ChakraDatePicker
      sx={(styles as any).field}
      locale={i18n.language}
      dateFormat="dd.MM.yyyy"
      showPopperArrow={false}
      customInput={
        <InputMask mask="99.99.9999">
          {((inputProps: any) => <TextInput {...inputProps}/>) as any}
        </InputMask>
      }
      {...props}
    />
  );
};

export default DateInput;
